export const pageSizes = [5, 10, 25, 50, 100] as const;
export type PaginationPageSize = (typeof pageSizes)[number];

export const EMPTY_PAGE = {
  result: [],
  totalCount: 0,
  pageSize: 0,
  pageIndex: 0,
  hasNext: false,
  filterValues: {},
};
